export async function transformToSmallThumbnail(url: string, accessToken?: string): Promise<string> {
  const urlObj = new URL(url)
  const pathname = urlObj.pathname

  const regex = /\/thumbnail(-\d+)?\.webp$/
  if (regex.test(pathname)) {
    // Extract the thumbnail number if present
    const match = pathname.match(regex)
    const thumbnailNumber = match?.[1] || ''
    const newFilename = `thumbnail${thumbnailNumber}_small.webp`

    // Call the core API to get a signed URL with the new filename
    try {
      if (!accessToken) {
        console.error('No access token available for signing thumbnail URL')
        return url // Return original URL as fallback
      }

      const response = await fetch('/core/api/protected/sign-thumbnail', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          url: url,
          filename: newFilename,
        }),
      })

      if (!response.ok) {
        console.error('Failed to sign thumbnail URL:', await response.text())
        return url // Return original URL as fallback
      }

      const { signedUrl } = await response.json()
      return signedUrl
    } catch (error) {
      console.error('Error calling sign-thumbnail API:', error)
      return url // Return original URL as fallback
    }
  }

  return url
}
